import React, { act } from "react";
import { Button, Typography, Box } from "@mui/material";
import { AccessTime, Block, CheckOutlined } from "@mui/icons-material";
import TripDialog from "../../../components/tripDialog/TripDialog";
import { approvalCellStyle } from "../style";
import { useLocation } from "react-router-dom";
import { TripAcceptance } from "../../../types/api";
import { useTranslation } from "react-i18next";

interface ApprovalCellRendererProps {
  value: string | null;
  tripId: number | null;
  tmsKey: string | null;
  tripAcceptance: TripAcceptance | null ;
  status?: string | null;
  onUpdate?: (tripId: string | null, newValue: string) => void;
  gridRef?:any
}

const ApprovalCellRenderer: React.FC<ApprovalCellRendererProps> = ({
  value,
  tripId,
  tmsKey,
  tripAcceptance,
  status,
  onUpdate,
  gridRef
}) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const location = useLocation();
  const isInTripDetails = location.pathname.includes("tripdetails");
  const {t} = useTranslation();
  const handleClick = () => {
    if (value === "TO APPROVE") {
      setDialogOpen(true);
    }
  };

  const handleCloseDialog = (action?: "APPROVED" | "REJECTED") => {
    setDialogOpen(false);
    if (action) {
      // Solo se l'utente ha scelto APPROVED o REJECTED
      if (onUpdate && tmsKey !== null) {
        onUpdate(tmsKey, action);
        setDialogOpen(false);
      }
    }
    setDialogOpen(false);
  };
  


  const renderApprovalButton = (buttonText: string) => {
    if (isInTripDetails) {
      // Se nella path "tripdetails", mostra un Box statico
      return (
        <Box sx={approvalCellStyle.approvedWrapper}>
          <AccessTime color="primary" fontSize="small" sx={approvalCellStyle.timeIcon} />
          <Typography sx={approvalCellStyle.checkText} color="primary">
            {buttonText}
          </Typography>
        </Box>
      );
    }

    // Altrimenti, mostra il pulsante cliccabile
    return (
      <Button
        variant="text"
        sx={approvalCellStyle.button}
        onClick={handleClick}
        startIcon={
          <AccessTime fontSize="small" sx={approvalCellStyle.timeIcon} />
        }
      >
        {buttonText}
      </Button>
    );
  };

  const renderContent = () => {
    switch (value) {
      case "TO APPROVE":
        return renderApprovalButton(t('screens.trips.approvalStatus.TO_APPROVE'));
      case "APPROVED":
        return (
          <Box sx={approvalCellStyle.approvedWrapper}>
            <CheckOutlined sx={approvalCellStyle.checkIcon} />
            <Typography sx={approvalCellStyle.checkText} color="text.primary">
            {tripAcceptance?.approvalStatusUser === "UDM" ? t('screens.trips.approvalStatus.AUTO_ACCEPTED') :t('screens.trips.approvalStatus.APPROVED')}
            </Typography>
          </Box>
        );
      case "REJECTED":
        return (
          <Box sx={approvalCellStyle.approvedWrapper}>
            <Block sx={approvalCellStyle.blockIcon} />
            <Typography sx={approvalCellStyle.checkText} color="text.primary">
           { t('screens.trips.approvalStatus.REJECTED')}
            </Typography>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {renderContent()}
      <TripDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        tripId={tripId}
        tmsKey={tmsKey}
        status={status}
        onUpdate={onUpdate}
        gridRef={gridRef} 
      />
    </>
  );
};

export default ApprovalCellRenderer;
